exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".doctorMenuInfoUnpublished[data-v-f81a9c4e]{opacity:.5}.doctorMenuDescription[data-v-f81a9c4e]{color:#757c83;font-size:14px;line-height:21px;margin-top:10px}.divide[data-v-f81a9c4e]{border-top:1px dotted #abb3ba}", ""]);

// exports
